"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var common_1 = require("@angular/common");
var common_module_1 = require("../common/common.module");
var core_1 = require("@angular/core");
var header_component_1 = require("./components/header.component");
var core_2 = require("@ngx-translate/core");
var HeaderModule = (function () {
    function HeaderModule() {
    }
    return HeaderModule;
}());
HeaderModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            router_1.RouterModule,
            core_2.TranslateModule,
            common_module_1.TRTCommonModule
        ],
        exports: [header_component_1.HeaderComponent],
        declarations: [header_component_1.HeaderComponent],
        providers: [],
    })
], HeaderModule);
exports.HeaderModule = HeaderModule;
var PCHeaderModule = (function () {
    function PCHeaderModule() {
    }
    return PCHeaderModule;
}());
PCHeaderModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            router_1.RouterModule,
            core_2.TranslateModule,
            common_module_1.TRTCommonModule
        ],
        exports: [header_component_1.PCHeaderComponent],
        declarations: [header_component_1.PCHeaderComponent],
        providers: [],
    })
], PCHeaderModule);
exports.PCHeaderModule = PCHeaderModule;
